import React from 'react';
import { TFunction } from 'i18next';
import NavIcon from './NavIcon';
import { NavIconKey } from '../constants/navIcons';

export interface NavigationItem {
  path?: string;
  label: string;
  icon: React.ReactNode;
  submenu?: Array<{
    path: string;
    label: string;
    icon: React.ReactNode;
  }>;
}

export const VOICE_DESTINATION_ROUTE_MAP: Record<string, string> = {
  dashboard: '/dashboard',
  contacts: '/contacts',
  invoices: '/invoices',
  expenses: '/expenses',
  reports: '/reports',
  settings: '/settings',
  'bank accounts': '/bank-accounts',
  inventory: '/inventory',
  'journal entries': '/journal-entries',
  'bulk payments': '/bulk-payments',
  'account transfers': '/account-transfers',
  'chart of accounts': '/chart-of-accounts',
  'tax periods': '/tax-periods',
  'image processing': '/image-processing',
};

const nav = (name: NavIconKey, size = 20) => <NavIcon name={name} size={size} />;

export const buildNavigationItems = ({
  t,
  isAccountant,
  isInventoryEnabled,
  isSuperAdmin,
}: {
  t: TFunction;
  isAccountant: boolean;
  isInventoryEnabled: boolean;
  isSuperAdmin: boolean;
}): NavigationItem[] => {
  if (isSuperAdmin) {
    return [
      {
        path: '/super-admin',
        label: t('navigation.superAdmin'),
        icon: nav('superAdmin'),
      },
    ];
  }

  return [
    {
      path: '/dashboard',
      label: t('navigation.dashboard'),
      icon: nav('dashboard'),
    },
    {
      path: '/contacts',
      label: t('navigation.contacts'),
      icon: nav('contacts'),
    },
    {
      path: '/bank-accounts',
      label: t('navigation.bankAccounts'),
      icon: nav('bankAccounts'),
    },
    ...(isInventoryEnabled
      ? [
          {
            path: '/inventory',
            label: t('navigation.inventory'),
            icon: nav('inventory'),
          },
        ]
      : []),
    {
      path: '/invoices',
      label: t('navigation.invoices'),
      icon: nav('invoices'),
    },
    {
      path: '/quotes',
      label: t('navigation.quotes'),
      icon: nav('quotes'),
    },
    {
      path: '/expenses',
      label: t('navigation.expenses'),
      icon: nav('expenses'),
    },
    ...(isAccountant
      ? [
          {
            label: t('navigation.accountant'),
            icon: nav('journalEntries'),
            submenu: [
              {
                path: '/journal-entries',
                label: t('navigation.journalEntries'),
                icon: nav('journalEntries', 16),
              },
              {
                path: '/bulk-payments',
                label: t('navigation.bulkPayments'),
                icon: nav('bulkPayments', 16),
              },
              {
                path: '/transfers',
                label: t('navigation.accountTransfers'),
                icon: nav('transfers', 16),
              },
              {
                path: '/reports',
                label: t('navigation.reports'),
                icon: nav('reports', 16),
              },
              {
                path: '/tax-periods',
                label: t('navigation.taxPeriods'),
                icon: nav('taxPeriods', 16),
              },
              {
                path: '/asp-operations',
                label: 'ASP Operations',
                icon: nav('reports', 16),
              },
            ],
          },
        ]
      : []),
    {
      path: '/chart-of-accounts',
      label: t('navigation.chartOfAccounts'),
      icon: nav('chartOfAccounts'),
    },
    {
      path: '/image-processing',
      label: t('navigation.imageProcessing'),
      icon: nav('imageProcessing'),
    },
    {
      path: '/business-management',
      label: t('navigation.businessManagement'),
      icon: nav('businessManagement'),
    },
    {
      path: '/settings',
      label: t('navigation.settings'),
      icon: nav('settings'),
    },
  ];
};
